import merge from "@tinkoff/utils/object/mergeDeep";
import { iso2ToCountryName } from "../countries";
const listSeriesToMapSeries = (series) => {
    return series.map((listSeries) => {
        return merge(listSeries, {
            joinBy: ["iso-a2", "code"],
            data: listSeries.data.map((point) => {
                let newMetric = point.metric;
                if (point.metric === undefined) {
                    //Fall back and use the y value.
                    newMetric = point.y;
                }
                return {
                    code: point.item,
                    id: point.item + listSeries.name,
                    location: iso2ToCountryName(point.item),
                    num: point.num,
                    per: point.per,
                    metric: newMetric,
                    y: point.y,
                    z: point.num,
                };
            }),
        });
    });
};
export default listSeriesToMapSeries;
